import { createAsyncThunk } from '@reduxjs/toolkit';
import { userApi } from 'container/userApi';
import { serializeError } from 'shared/utils/redux';
import { PaginatedUserListSendDto } from 'api/dto/User.dto';

import { STORE_NAME } from './initialState';

export const fetchUserList = createAsyncThunk(
  `${STORE_NAME}/fetchUserList`,
  ({ projectId, query }: { projectId: number; query?: PaginatedUserListSendDto }) => {
    return userApi.listPaginated(projectId, query);
  },
  { serializeError },
);

export const uploadExcel = createAsyncThunk(
  `${STORE_NAME}/uploadExcel`,
  ({ file, projectId }: { file: File; projectId: number }) => {
    return userApi.uploadExcel(file, projectId);
  },
  { serializeError },
);
